<div [ngSwitch]="aPanelData.type">
    <div *ngSwitchCase="'block'">
      <div [innerHTML]="app.bypassHtmlSanitizing(aPanelData.content)"></div>
    </div>
    <div *ngSwitchDefault>
      <manager-wgt [aWidgetParams]="aPanelData"></manager-wgt>
    </div>
</div>